import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { initializeIAP } from '../services/iap';

const isNative = () => Capacitor.isNativePlatform();
const isIOS = () => Capacitor.getPlatform() === 'ios';
const isAndroid = () => Capacitor.getPlatform() === 'android';

export default function useNativeSetup() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    (async () => {
      try {
        if (isIOS() || isAndroid()) {
          const { StatusBar, Style } = await import('@capacitor/status-bar');
          await StatusBar.setStyle({ style: Style.Light });
          if (isAndroid()) await StatusBar.setBackgroundColor({ color: '#ffffff' });
        }

        if (isNative()) {
          const { SplashScreen } = await import('@capacitor/splash-screen');
          await SplashScreen.hide();
        }

        if (isAndroid()) {
          const { App } = await import('@capacitor/app');
          App.addListener('backButton', ({ canGoBack }) => {
            if (canGoBack) window.history.back();
            else App.exitApp();
          });
        }

        if (isNative()) {
          const { App } = await import('@capacitor/app');
          App.addListener('appUrlOpen', async ({ url }) => {
            if (url?.includes('/auth/callback')) {
              try {
                const { Browser } = await import('@capacitor/browser');
                await Browser.close();
              } catch {}
            }
          });
        }

        if (isIOS()) {
          // CdvPurchase store init — products will only load if App Store
          // Connect has the subscription products in "Ready to Submit" state.
          // On a fresh app with no products configured, this is a no-op.
          try { initializeIAP(); } catch (err) { console.warn('IAP init failed:', err); }
        }
      } catch (err) {
        console.warn('Native setup error (non-fatal):', err);
      }
    })();
  }, []);
}
